// extracted by mini-css-extract-plugin
export default {"pagination":"_070d3d4efd","pageItem":"_669a6b7740 _26cbf6c5bd _81a15fa26b","active":"_409ae80f9a","disabled":"f29b2fe729","arrowIcon":"_1257688adc"};